import { useContext } from 'react';

import { AnnouncementsDialogContext } from 'contexts/AnnouncementsDialog';

const useAnnouncementsDialog = () => {
  return useContext(AnnouncementsDialogContext);
};

export default useAnnouncementsDialog;
